export const tagOptions = [
	{ value: 'originacion_camionetas', label: 'Originación Camionetas' },
	{ value: 'soporte', label: 'Soporte' },
	{ value: 'onboarding', label: 'Onboarding' },
	{ value: 'originacion_microcredito', label: 'Originación Microcrédito' },
	{ value: 'continuar_conversacion_credito', label: 'Continuar Conversación Crédito' },
	{ value: 'cobranza', label: 'Cobranza' }
];

export function removeTimestamp(input: string): string {
	const lastUnderscoreIndex = input.lastIndexOf('_');
	if (lastUnderscoreIndex === -1 || isNaN(Number(input[lastUnderscoreIndex + 1]))) {
		return input;
	}
	return input.substring(0, lastUnderscoreIndex);
}

export function toSnakeCase(str: string): string {
	return str
		.toLowerCase()
		.replace(/\s+/g, '_')
		.replace(/^_+|_+$/g, '');
}
